export class NoSessionError extends Error {
  constructor() {
    super('No current user');
    this.name = 'NoSessionError';
  }
}
